module.exports = require('./helpers/bundle-url').getBundleURL('6xKsm') + "logo-dark.eefe0b7f.svg";